export const transformApiFieldsToInternal = (apiFields) => {
  if (!apiFields || !Array.isArray(apiFields)) return [];

  return apiFields.map((field) => ({
    id: field.id,
    type: field.fieldType,
    label: field.name,
    required: field.required || false,
    order: field.position,
    systemLocked: field.systemLocked || false,
    ...(field.fieldType === 'select' || field.fieldType === 'checkbox'
      ? {
          options: Array.isArray(field.options) ? field.options : [],
          allowMultiple: field.allowMultiple ?? false,
        }
      : {}),
  }));
};
